import React, { useEffect } from "react";
import { HOMEPAGE } from "@/constants/testIds";
import CaptecHome from "@/components/home/CaptecHome";

const Home = () => {
  useEffect(() => {
    document.title = "Captec — Tecnología de medios de pago";
  }, []);

  return (
    <div data-testid={HOMEPAGE.root}>
      <CaptecHome />
    </div>
  );
};

export default Home;
